import { configureStore } from "@reduxjs/toolkit";
import themeSlice from "./features/theme";

const store = configureStore({
  reducer: {
    theme: themeSlice,
  },
});

type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export default store;
